import {useAtom} from 'jotai'

import {transactionAtom, transactionDetailAtom} from '../store/transaction'

export const useTransaction = () => {
  const [transaction, transactionSet] = useAtom(transactionAtom)

  return {transaction, transactionSet}
}

export const useTransactionDetail = () => {
  const [transactionDetail, transactionDetailSet] = useAtom(transactionDetailAtom)

  return {transactionDetail, transactionDetailSet}
}
